var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 17",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.385 17h9.23C11.38 17 12 16.33 12 15.506V4.98H8.77c-.764 0-1.385-.67-1.385-1.494V0h-6C.62 0 0 .67 0 1.494v14.012C0 16.33.621 17 1.385 17ZM3.23 7.006h5.538c.255 0 .462.223.462.498s-.207.498-.462.498H3.231c-.255 0-.462-.223-.462-.498s.207-.498.462-.498Zm0 1.992h5.538c.255 0 .462.223.462.498s-.207.498-.462.498H3.231c-.255 0-.462-.223-.462-.498s.207-.498.462-.498Zm0 1.992h5.538c.255 0 .462.223.462.498 0 .276-.207.498-.462.498H3.231c-.255 0-.462-.222-.462-.498 0-.275.207-.498.462-.498Zm0 1.992h3.692c.255 0 .462.223.462.498 0 .276-.207.499-.462.499H3.231c-.255 0-.462-.223-.462-.499 0-.275.207-.498.462-.498Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77 3.984h2.96L8.308.292v3.194c0 .275.207.498.461.498Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon_text.be543bb2bdcc209dafecd19d0be33bee.svg";
export { ForwardRef as ReactComponent };